import React from "react";
import logo from './cosmologo.png';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Api from "./screens/Api";
import Login from './screens/Login';
import AuthLogin from './screens/AuthLogin';
import ChangePasswordScreen from './screens/ChangePasswprdScreen';
import ExitRequestScreen from './screens/ExitRequestScreen';
import GenerateQRCode from './screens/GenerateQRCode';
import MainMenu from './screens/MainMenu';
import ProfileScreen from './screens/ProfileScreen';
import RegisterScreen from './screens/RegisterScreen';
import RequestDetailScreen from './screens/RequestDetailScreen';
import RequestHistoryScreen from './screens/RequestHistoryScreen';
import StudentDetailsScreen from './screens/StudentDetailsScreen';

import './App.css';

const Home = () => (
  <div style={styles.container}>
    <img src={logo} className="App-logo" alt="logo" />
    <h1 style={{fontFamily: "sans-serif"}}>COSMOPOLITAN UNIVERSITY</h1>
    <Link to="AuthLogin" style={styles.link}>Proceed</Link>
  </div>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/Home" element={<Home />} />
        <Route path="/api" element={<Api />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/" element={<AuthLogin />} />
        <Route path="/ChangePassword" element={<ChangePasswordScreen />} />
        <Route path="/ExitRequest" element={<ExitRequestScreen />} />
        <Route path="/QRCode" element={<GenerateQRCode />} />
        <Route path="/Menu" element={<MainMenu />} />
        <Route path="/Profile" element={<ProfileScreen />} />
        <Route path="/Register" element={<RegisterScreen />} />
        <Route path="/RequestDetail" element={<RequestDetailScreen />} />
        <Route path="/RequestHistory" element={<RequestHistoryScreen />} />
        <Route path="/StudentDetails" element={<StudentDetailsScreen />} />
      </Routes>
    </Router>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
  },
  link: {
    marginTop: "20px",
    padding: "10px 15px",
    backgroundColor: '#013a64',
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px",
  },
};

export default App;
